import { useState } from 'react';
import { toast } from 'sonner';
import { t } from '@/shared/i18n/t';
import { replica } from '@/shared/sync/replica';
import type { Attachment } from './attachment';

/** Store picked files on this device (uploaded on the next sync) and return their references. */
export function useAddFiles(onAdded: (added: readonly Attachment[]) => void) {
  const [busy, setBusy] = useState(false);

  async function add(files: FileList | null) {
    if (!files?.length) return;
    setBusy(true);
    const added: Attachment[] = [];
    for (const file of Array.from(files)) {
      try {
        added.push(await replica.files.add(file));
      } catch {
        toast.error(t('{name}: could not be added (50 MB at most)', { name: file.name }));
      }
    }
    setBusy(false);
    onAdded(added);
  }

  return { busy, add };
}
